import { Component, OnInit } from '@angular/core';
import { ShapeComponent } from '../shape/shape.component';
import { MousePosition, WatermarkBox } from '../../model/shape';
import { ShapeType } from '../../model/shape-types';

@Component({
  selector: 'app-watermark',
  templateUrl: './watermark.component.html',
  styleUrls: ['./watermark.component.scss']
})
export class WatermarkComponent extends ShapeComponent implements OnInit {

  formFields = [
    {
        name: 'x',
        label: 'X:',
        type: 'input',
        inputType: 'text',
        value: ''
    },
  ];

  constructor() {
    super();
    // console.log('ImgeComponent constructor');
    this.shape = new WatermarkBox();
    this.shapeType = ShapeType.Watermark;
  }

  ngOnInit() {
    // console.log('ImageComponent ngOnInit');
  }

  startDrawing(beginPosition: MousePosition): void {
    if (this.shape instanceof WatermarkBox) {
        this.shape.originX = beginPosition.x;
        this.shape.originY = beginPosition.y;
    }
    // console.log('ImageComponent startDrawing at ', beginPosition, ', ', this.shape);
  }

  draw(currentPosition: MousePosition): void {
    // console.log('ImageComponent draw');
    if (this.shape instanceof WatermarkBox) {
        this.shape.width = Math.abs(currentPosition.x - this.shape.originX);
        this.shape.height = Math.abs(currentPosition.y - this.shape.originY);
    }
  }

}
